import { isoString, systemClock, type Clock } from "../time.js";
import type { Calendar, CalendarPatch } from "./types.js";

/** Apply a patch and bump updated_at. Immutable: returns a new object. */
export function updateCalendar(calendar: Calendar, patch: CalendarPatch, now: Clock = systemClock): Calendar {
  return {
    ...calendar,
    ...patch,
    id: calendar.id,
    created_at: calendar.created_at,
    updated_at: isoString(now()),
  };
}

/** Soft-delete: sets deleted_at without removing the row. */
export function softDeleteCalendar(calendar: Calendar, now: Clock = systemClock): Calendar {
  const ts = isoString(now());
  return { ...calendar, deleted_at: ts, updated_at: ts };
}
